// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discardChangeContainer_SYw8R {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--white-color);
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  width: 50%;
  -o-border-radius: 10px;
  .content_CToKO {
    width: 85%;
    margin: 0 auto;
    padding: 20px 0px;
    p {
      margin: 0;
      color: #38343d;
      font-size: 14px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DiscardChange/DiscardChange.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB;IACE,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB;MACE,SAAS;MACT,cAAc;MACd,eAAe;IACjB;EACF;AACF","sourcesContent":[".discardChangeContainer {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--white-color);\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  width: 50%;\n  -o-border-radius: 10px;\n  .content {\n    width: 85%;\n    margin: 0 auto;\n    padding: 20px 0px;\n    p {\n      margin: 0;\n      color: #38343d;\n      font-size: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"discardChangeContainer": `discardChangeContainer_SYw8R`,
	"content": `content_CToKO`
};
export default ___CSS_LOADER_EXPORT___;
